import { c as _c } from "react/compiler-runtime";
import { MantineContext, MantineProvider, MantineProviderProps, useMantineContext } from '@mantine/core';
import React, { ReactNode, useContext } from 'react';
export const ThemeOverride = t0 => {
  const $ = _c(4);
  const {
    children,
    override
  } = t0;
  const ctx = useContext(MantineContext);
  let t1;
  if ($[0] !== children || $[1] !== ctx || $[2] !== override) {
    t1 = ctx ? <MantineContext.Provider value={{
      ...ctx,
      ...override
    }}>{children}</MantineContext.Provider> : children;
    $[0] = children;
    $[1] = ctx;
    $[2] = override;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export const SharedContext = React.createContext<{
  mantine?: MantineProviderProps;
}>({});

/** Some react context. Like mantine does't cross the project boundary. Use this to do that */
export const ContextForShared = t0 => {
  const $ = _c(5);
  const {
    children,
    mantine
  } = t0;
  let t1;
  if ($[0] !== mantine) {
    t1 = {
      mantine
    };
    $[0] = mantine;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <SharedContext.Provider value={t1}>{children}</SharedContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const ContextInShared = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    mantine
  } = useContext(SharedContext);
  let t1;
  if ($[0] !== children || $[1] !== mantine) {
    t1 = <MantineProvider {...mantine}>{children}</MantineProvider>;
    $[0] = children;
    $[1] = mantine;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};